<template>
   <header>
      <div id="header-sticky"
         :class="`${isSticky ? 'header-area header-transparent header-pad header-border sticky' : 'header-area header-transparent header-pad header-border'}`">
         <div class="container-fluid">
            <div class="row align-items-center">
               <div class="col-xl-2 col-lg-2 col-6">
                  <div class="logo logo-border">
                     <router-link to="/">
                        <img class="logo-white" src="../../assets/img/logo/logoMOPH.png" alt="logo">
                     </router-link>
                  </div>
               </div>
               <div class="col-xl-8 col-lg-8 d-none d-lg-block">
                  <div class="main-menu text-center">
                     <nav id="mobile-menu">
                        <ul>
                           <li> <router-link to="/">Home</router-link></li>
                           <li> <router-link to="/#pricing2">Donate</router-link></li>
                           <li> <router-link to="/#news">News</router-link></li>
                           <li> <router-link to="/#calendar">Events</router-link></li>
                           <li> <router-link to="/#partners">Partners</router-link></li>
                           <li> <router-link to="/contact">Contact</router-link></li>
                        </ul>

                     </nav>
                  </div>
               </div>
               <div class="col-xl-2 col-lg-2 col-6">
                  <div class="header-right-info d-flex align-items-center justify-content-end">
                     <div class="sidebar__menu d-lg-none">
                        <div @click="menuOption.menuShow = !menuOption.menuShow" class="sidebar-toggle-btn ml-30"
                           id="sidebar-toggle">
                           <span class="line"></span>
                           <span class="line"></span>
                           <span class="line"></span>

                        </div>
                     </div>
                     <div class="header-btn d-none d-lg-block">
                        <router-link to="/contact" class="tp-btn">Contact</router-link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </header>

   <!-- search popup area start -->
   <div :class="`${searchPopup ? 'search__popup transition-3 opened' : 'search__popup transition-3'}`">
      <div class="search__popup-close">
         <button type="button" class="search-popup-close-btn" @click="handleClose">
            <i class="fal fa-times"></i>
         </button>
      </div>
      <div class="search__popup-wrapper">
         <form action="#">
            <div class="search__popup-input">
               <input type="text" placeholder="Enter Your Keyword...">
               <button type="submit"><i class="far fa-search"></i> </button>
            </div>
         </form>
      </div>
   </div>
   <!-- search popup area end -->

   <!-- Mobile Menu Start -->
   <div class="fix">
      <div class="side-mobile-menu" :class="[menuOption.menuShow === true ? 'active' : '']">
         <div class="sidebar__wrapper">
            <div @click="menuOption.menuShow = !menuOption.menuShow" class="sidebar__close">
               <button class="sidebar__close-btn" id="sidebar__close-btn">
                  <i class="fal fa-times"></i>
               </button>
            </div>
            <div class="sidebar__content">
               <div class="logo mb-40">
                  <a href="index.html">
                     <img src="../../assets/img/logo/logoMOPH.png" alt="logo">
                  </a>
               </div>
               <div class="mobile-menu fix">
                  <div class="side-info-content sidebar-menu mm-menu">
                     <ul>
                        <li> <router-link to="/">Home</router-link></li>
                        <li> <router-link to="/#pricing2">Donate</router-link></li>
                        <li> <router-link to="/#news">News</router-link></li>
                        <li> <router-link to="/#calendar">Events</router-link></li>
                        <li> <router-link to="/#partners">Partners</router-link></li>
                        <li> <router-link to="/contact">Contact</router-link></li>
                     </ul>
                  </div>
               </div>
               <br>
               <div class="sidebar__contact mb-45">
                  <ul>
                     <li>
                        <div class="icon theme-color ">
                           <i class="fal fa-envelope"></i>
                        </div>
                        <div class="text theme-color ">
                           <span><a href="mailto:gatortogator@aol.com">gatortogator@aol.com</a></span>
                        </div>
                     </li>

                     <li>
                        <div class="icon theme-color">
                           <i class="fas fa-phone-volume"></i>
                        </div>
                        <div class="text theme-color">
                           <span><a href="tel:(720) 206-8353">(720) 206-8353</a></span>
                        </div>
                     </li>

                     <li>
                        <div class="icon">
                           <i class="fal fa-map-marker-alt"></i>
                        </div>
                        <div class="text">
                           <a target="_blank"
                              href="https://maps.app.goo.gl/4BfDm4qG5BYq4PVt6">15821 E Centretech Cir, Aurora, CO 80011</a>
                        </div>
                     </li>
                  </ul>
               </div>
            </div>
         </div>
      </div>
   </div>

   <div class="body-overlay transition-3" :class="[menuOption.menuShow === true ? 'opened' : '']">
   </div>
   <!-- Mobile Menu End -->
</template>

<script>

export default {
   name: 'HomeHeader',
   data() {
      return {
         isSticky: false,
         searchPopup: false,
         menuOption: {
            menuShow: false,
            menuSearch: false,
            homeDropdown: false,
            serviceDropdown: false,
            pagesDropDown: false,
            blogDropdown: false,
            aboutDropdown: false,
         },
      }
   },
   methods: {
      handleSticky() {
         if (window.scrollY > 80) {
            this.isSticky = true;
         }
         else {
            this.isSticky = false;
         }
      },
      handleSearch() {
         this.searchPopup = true;
      },
      handleClose() {
         this.searchPopup = false;
      }
   },
   mounted() {
      window.addEventListener('scroll', this.handleSticky)
   },
}
</script>
